import React, { Fragment, memo, useCallback, useMemo } from 'react';
import Map from '../Map';
import SkuCards from '@/shared/crisp/SkuCards';
import { PDPCardLoader } from '@/shared/crisp/Loaders/SkuCards';
import is from '@/utils/is';
import ProductNotFound from '../Product/ProductNotFound';
import { getProductURL } from '@/utils/urls';

type ProductListingProps = {
  list: any[] | any;
  isLoading: boolean;
  page: number;
};

const loaderList = [
  {
    isLoader: true,
  },
  {
    isLoader: true,
  },
  {
    isLoader: true,
  },
  {
    isLoader: true,
  },
];

const ProductListing = ({ list, isLoading, page }: ProductListingProps) => {
  const render = useCallback(
    (item: any, index: number) => {
      if (item.isLoader) {
        return isLoading ? <PDPCardLoader key={'loader' + index} /> : null;
      }
      return (
        <SkuCards dataTestId="sku-card" key={item.id + '' + index} type="PDPCard" data={item} />
      );
    },
    [isLoading],
  );

  const productList = useMemo(() => {
    if (page === 1 && isLoading) {
      return loaderList;
    }
    return is.not.empty.array(list) && list.concat(loaderList);
  }, [isLoading, page, list]);

  const structuredData = useMemo(() => {
    if (productList) {
      return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: productList.map(({ attributes }: any, index: number) => ({
          '@type': 'ListItem',
          position: index + 1,
          url: `www.eurekaforbes.com/${getProductURL(attributes?.materialId, attributes?.slug)}`,
          name: attributes?.plainName,
        })),
      };
    }
    return {};
  }, [productList]);

  if (is.empty.array(list)) {
    return <ProductNotFound />;
  }

  return (
    <Fragment>
      <Map
        className="grid gap-s6 md:gap-s7 py-s6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"
        list={productList}
        render={render}
      />
      <script
        id="plp-list"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(structuredData),
        }}
      />
    </Fragment>
  );
};

export default memo(ProductListing);
